/**
 * Formatting utilities for product detail components
 */

/**
 * Format a currency value with optional compact notation
 */
export const formatCurrency = (value: number | string, compact = true): string => {
  const num = typeof value === 'string' ? parseFloat(value) : value;
  if (compact) {
    if (num >= 1_000_000_000) return `$${(num / 1_000_000_000).toFixed(1)}B`;
    if (num >= 1_000_000) return `$${(num / 1_000_000).toFixed(1)}M`;
    if (num >= 1_000) return `$${(num / 1_000).toFixed(1)}K`;
  }
  return `$${num.toLocaleString()}`;
};

/**
 * Format a number with optional compact notation
 */
export const formatNumber = (value: number | string, compact = true): string => {
  const num = typeof value === 'string' ? parseFloat(value) : value;
  if (compact) {
    if (num >= 1_000_000) return `${(num / 1_000_000).toFixed(1)}M`;
    if (num >= 1_000) return `${(num / 1_000).toFixed(1)}K`;
  }
  return num.toLocaleString();
};
